//var apiUrl = 'https://api.jsitc.net.cn';
//var webUrl = 'https://api.jsitc.net.cn';

var apiUrl = 'https://www.jsitc.net.cn';
var webUrl = 'https://www.jsitc.net.cn';

//var apiUrl = 'http://172.16.3.152:8088';
//var webUrl = 'http://192.168.0.91:8082';

export default {
	apiUrl: apiUrl,
	webUrl: webUrl
}